import { render, staticRenderFns } from "./SearchResultsBody.vue?vue&type=template&id=722e6c80"
import script from "./SearchResultsBody.vue?vue&type=script&lang=js"
export * from "./SearchResultsBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports